/* import __COLOCATED_TEMPLATE__ from './help.hbs'; */
import Component from '@glimmer/component';
import Constants from '../../utils/constants';

export default class HelpModal extends Component {
  get modalType() {
    return Constants.MODAL_TYPES.HELP.value;
  }
}
